export const getStringFirstLetter = (str: string): string => str?.[0].toUpperCase()
